import { func } from 'prop-types';
import React from 'react';
import {
  Form,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import createModalToggle from '../../generic/create-modal-toggle';
import FileDownloader from '../../generic/FileDownloader';
import FilePreview from '../../generic/FilePreview';
import { quoteShape } from '../../prop-types';
import api from '../../REST/api';
import getEventTargetValue from '../../utils/get-event-target-value';

const exportParams = {
  displayCountries: 'Display one Country per line',
  displayGenders: 'Display Genders',
  displayCategories: 'Display Categories',
  displayTarget: 'Display Target KPI and Target value',
  displayBillingType: 'Display Billing Type',
  listSubcategories: 'List all subcategories',
  joinWithTerms: 'Append applicable Terms and Conditions',
  appendCreativeGuidelines: 'Append applicable Creative Guidelines',
};

class QuoteDownloadOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      displayCountries: false,
      displayGenders: true,
      displayCategories: true,
      displayTarget: false,
      displayBillingType: false,
      joinWithTerms: true,
      listSubcategories: false,
      secondaryContact: null,
      appendCreativeGuidelines: false,
      loadingSecondaryContact: !!props.quote.secondaryContactId,
    };

    this.handleGetFile = this.handleGetFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { secondaryContactId } = this.props.quote;
    if (secondaryContactId) {
      api
        .getContact({ id: secondaryContactId })
        .then(secondaryContact => this.setState({ secondaryContact }))
        .finally(() => this.setState({ loadingSecondaryContact: false }));
    }
  }

  handleGetFile() {
    return api.exportQuote({
      id: this.props.quote.id,
      exportParams: this.getParams(),
    });
  }

  handleChange(evt) {
    const { target } = evt;
    const { name } = target;
    const value = getEventTargetValue(target);
    this.setState({ [name]: value });
  }

  getParams() {
    const keys = Object.keys(exportParams);
    return keys.reduce((accumulator, paramKey) => {
      accumulator[paramKey] = this.state[paramKey] ? 1 : 0;
      return accumulator;
    }, {});
  }

  render() {
    const { onSuccess, toggle } = this.props;
    return (
      <>
        <ModalHeader toggle={toggle}>Customize Quote Export</ModalHeader>
        <ModalBody>
          <Form>
            {Object.keys(exportParams).map(key => (
              <FormGroup check key={key}>
                <Label check inline="true" for={key}>
                  <Input
                    type="checkbox"
                    name={key}
                    id={key}
                    checked={this.state[key]}
                    onChange={this.handleChange}
                    disabled={
                      exportParams[key] ===
                      exportParams.appendCreativeGuidelines
                    }
                  />
                  {exportParams[key]}
                </Label>
              </FormGroup>
            ))}
          </Form>
        </ModalBody>
        <ModalFooter className="justify-content-start">
          <FilePreview queryFn={this.handleGetFile} title="IO Preview" />
          <FileDownloader
            onGetFile={this.handleGetFile}
            onFileDownloadSuccess={onSuccess}
          />
        </ModalFooter>
      </>
    );
  }
}

QuoteDownloadOptions.propTypes = {
  quote: quoteShape.isRequired,
  toggle: func.isRequired,
  onSuccess: func.isRequired,
};

export default createModalToggle(
  'Download',
  QuoteDownloadOptions,
  { className: 'ml-2 d-inline-block' },
  { size: 'lg' },
);
export { QuoteDownloadOptions };
